import VN from "../components/VN";
import { fetchUserData } from "../services/userService";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Container, Paper, Typography } from "@mui/material";
import GppBadIcon from "@mui/icons-material/GppBad";

export default function NoPermission() {
  const [userData, setUserData] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/login", { replace: true });
    }, 5000);

    const verifyUser = async () => {
      try {
        const userDataAnswer = await fetchUserData();

        if (userDataAnswer && userDataAnswer.userId) {
          setUserData(userDataAnswer);
        } else {
          navigate("/login", { replace: true });
        }
      } catch (error) {
        console.error("Error during user verification:", error);
        navigate("/login", { replace: true });
      }
    };

    verifyUser();

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <Box className="bodyReminder" sx={{ minHeight: "100vh" }}>
      {userData?.userId > 0 && <VN userData={userData} />}

      <Container maxWidth="md" sx={{ mt: { xs: 4, md: 8 }, mb: 6 }}>
        <Paper
          elevation={8}
          sx={{
            background:
              "linear-gradient(135deg, #b71c1c 0%, #d32f2f 60%, #f44336 100%)",
            color: "#fff",
            borderRadius: 4,
            p: { xs: 3, sm: 5 },
            textAlign: "center",
            border: "3px solid #8e0000",
            boxShadow: "0 12px 35px rgba(183, 28, 28, 0.35)",
          }}
        >
          <GppBadIcon
            sx={{
              fontSize: { xs: 64, sm: 88 },
              mb: 1,
              filter: "drop-shadow(0 3px 4px rgba(0,0,0,0.25))",
            }}
          />

          <Typography
            variant="h3"
            component="h1"
            sx={{
              fontWeight: 900,
              textTransform: "uppercase",
              letterSpacing: { xs: 1, sm: 2 },
              fontSize: { xs: "1.8rem", sm: "2.8rem" },
              mb: 2,
            }}
          >
            Brak uprawnień
          </Typography>

          <Box
            sx={{
              width: 90,
              height: 5,
              bgcolor: "#fff",
              borderRadius: 5,
              mx: "auto",
              mb: 3,
            }}
          />

          <Typography
            variant="h6"
            sx={{
              fontWeight: 500,
              lineHeight: 1.7,
              fontSize: { xs: "1rem", sm: "1.25rem" },
            }}
          >
            Nie masz uprawnień do wyświetlenia tej strony.
          </Typography>

          <Typography
            sx={{
              mt: 1.5,
              opacity: 0.95,
              fontSize: { xs: "0.9rem", sm: "1rem" },
            }}
          >
            Jeśli uważasz, że to pomyłka, skontaktuj się z administratorem.
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
}
